module.exports = __webpack_public_path__ + "static/media/1_CONNECTED TO CATS-EYES BRACELET_DE.699fe863.txt";